import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="download-button"
export default class extends Controller {
  static targets = ["downloadText", "spinner"]

  connect() {
    console.log("Download Button controller connected")
  }
  
  startDownload(event) {
    // Show loading state
    this.downloadTextTarget.textContent = "Generando...";
    this.spinnerTarget.classList.remove("hidden");
    this.element.classList.add("opacity-75", "cursor-not-allowed");
    
    // After 3 seconds, reset the button state (the file should be downloading by then)
    setTimeout(() => {
      this.downloadTextTarget.textContent = "Descargar Excel";
      this.spinnerTarget.classList.add("hidden");
      this.element.classList.remove("opacity-75", "cursor-not-allowed");
    }, 3000);
  }
}
